import {inject} from '@angular/core';
import {CanActivateFn, CanDeactivateFn, Router, UrlTree} from '@angular/router';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {EMaintenanceMode} from '../enums/maintenance-mode.enum';
import {maintenanceMode} from '../state/maintenance-mode.actions';

export const maintenanceModeGuard: CanActivateFn = () => {
  if (environment.showMaintenancePage === EMaintenanceMode.YES) {
    inject(Store).dispatch(maintenanceMode({MaintenanceModeStatus: true}));
    return inject(Router).createUrlTree(['/maintenance-mode']);
  }
  return true;
};

export const maintenanceDeactivateModeGuard: CanDeactivateFn<
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
> = (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  if (environment.showMaintenancePage !== EMaintenanceMode.YES) {
    inject(Store).dispatch(maintenanceMode({MaintenanceModeStatus: false}));
    return inject(Router).createUrlTree(['/my-orders']);
  } else {
    inject(Store).dispatch(maintenanceMode({MaintenanceModeStatus: true}));
  }
  return true;
};
